module.exports = __webpack_public_path__ + "static/zoom-out.f0f0779e852745780e33bba800dcfb39.svg";